/// <reference types="vite/client" />
import { ServiceId } from '@spectee/graphql/api';
import { Stage, validateStage } from '../../lib/stage';

const stage = import.meta.env.MODE ?? 'NONE';
if (!validateStage(stage)) throw Error(`Invalid STAGE: ${stage}`);

// ******************************************scr*****************************************
// Options ID's
// NA
// license ID's
const ScrID =
  stage === Stage.production ? 'rol_DGUvc7PHTpTtTqe1' : 'rol_QHuZ2PPA8PlP0xot'; // SCRフル

const SrmWebID =
  stage === Stage.production ? 'rol_QhuonN6So0i7ZcY3' : 'rol_zBqk9GgxtVT1g2Uq';
// ******************************************pro*****************************************
// Options ID's
const SpotStatusFinderID =
  stage === Stage.production ? 'rol_Y3h8jo6TMRkQxJt0' : 'rol_Qv7lnN02Z6rTBsiW'; // 拠点ステータスファインダー
const ScrSupplierConnectorID =
  stage === Stage.production ? 'rol_ffjF0NShVSXYbrJ5' : 'rol_cxaJucp3EC5EFlkg'; // 仕入先コネクター
// license ID's
const ProID =
  stage === Stage.production ? 'rol_InHxEzz0FMbwrZs0' : 'rol_puJv7CR7lzQul7eo'; // フル
const ProAppOnlyID =
  stage === Stage.production ? 'rol_Xnt67MMqdOFwEwjv' : 'rol_lHxClmf6MwRSbEzM'; // アプリのみ
const ProGroupPostOnlyID =
  stage === Stage.production ? 'rol_pyd4BFJEsrJK7k9d' : 'rol_s1ptYhxxzuhvhRcm'; // グループ投稿のみ
const ProRiskMonitoringID =
  stage === Stage.production ? 'rol_EGBuYsI2x3lZh6KA' : 'rol_8vDboOFGoxuwvuDH'; // リスク監視

type ServiceLicenseSettingType = {
  serviceId: ServiceId;
  options: {
    key: string; // For understanding purpose
    id: string; // Role ID is saved in id , relates with auth0 role_id
    name: string; // It will used to display in screen components name
    defaultCheck: boolean; // If need to check with default,then mention it as "true"
  }[];
  licenses: {
    key: string; // For understanding purpose
    id: string; // Role ID is saved in id , relates with auth0 role_id
    name: string; // It will used to display in screen components name
    defaultVal: number; // If need to set any default value,then mention the value here (Note : defaultVal > 0 , the fields show on screen default )
  }[];
}[];

export const serviceLicenseSettingData: ServiceLicenseSettingType = [
  {
    serviceId: ServiceId.pro,
    options: [
      {
        key: 'spotStatusFinder',
        id: SpotStatusFinderID,
        name: '拠点ステータスファインダー',
        defaultCheck: false,
      },
    ],
    licenses: [
      { key: 'full', id: ProID, name: 'Web+アプリ', defaultVal: 0 },
      { key: 'appOnly', id: ProAppOnlyID, name: 'アプリのみ', defaultVal: 0 },
      {
        key: 'groupPostOnly',
        id: ProGroupPostOnlyID,
        name: 'グループ投稿のみ',
        defaultVal: 0,
      },
      {
        key: 'riskMonitoring',
        id: ProRiskMonitoringID,
        name: 'リスク監視',
        defaultVal: 0,
      },
    ],
  },
  {
    serviceId: ServiceId.scr,
    options: [
      {
        key: 'supplierConnector',
        id: ScrSupplierConnectorID,
        name: 'サプライヤー',
        defaultCheck: false,
      },
    ],
    licenses: [
      {
        key: 'scrFull',
        id: ScrID,
        name: 'Web',
        defaultVal: 0,
      },
    ],
  },
  {
    serviceId: ServiceId.srm,
    options: [],
    licenses: [
      {
        key: 'licenseSpecteeForSrmWeb',
        id: SrmWebID,
        name: 'スマートリスク管理',
        defaultVal: 0,
      },
    ],
  },
];
